import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LookupService } from '@core/services/lookup.service';
import { ISchool } from '@views/features/management/interfaces/isearchSchool';
import { tap } from 'rxjs';

@Component({
  selector: 'prism-select-school',
  templateUrl: './select-school.component.html',
  styleUrl: './select-school.component.scss'
})
export class SelectSchoolComponent implements OnChanges {
  @Output() school = new EventEmitter<any>();
  @Input() selectedSchool?: number | null;
  @Input() control!: FormControl | any;
  @Input() label: string = '';
  @Input() required: boolean = false;
  @Input() readOnly?: boolean = false;
  @Input() labelClass: string = '';
  @Input() districtId: number | null = null;
  @Input() options: ISchool[] = [];

  constructor(private lookupService: LookupService) {}

  ngOnInit(): void {
    this.getSchools();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['districtId']) {
      if (!changes['districtId'].firstChange && this.control?.value) {
        this.control.setValue(null);
        this.school.emit(null);
      }
      this.getSchools();
    }
  }

  getSchools(): void {
    if (this.districtId) {
      this.lookupService.getSchoolsByDistrict(this.districtId)
        .pipe(
          tap((res: ISchool[]) => this.options = res)
        )
        .subscribe();
    } else {
      this.options = [];
    }
  }

  emitSchool(school: any): void {
    this.school.emit(school);
  }
}